import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isMailboxSharedResourceArchive } from "owa-account-shared-mailbox-utils";
import { getMailboxInfoForCoprincipalAccount } from "owa-mailbox-info/lib/getMailboxInfoForCoprincipalAccount";

/**
 * The service stores a single move-to MRU list per user in the primary mailbox, so the user's
 * own online archive shares the MRU list (and store) of its coprincipal account.
 */
export default function getMoveToMruMailboxInfo(mailboxInfo: MailboxInfo): MailboxInfo {
    if (mailboxInfo?.type !== "ArchiveMailbox" ||
        isMailboxSharedResourceArchive(mailboxInfo) ||
        !isGlobalFeatureEnabled("fp-movetofolder-mru-archive")) {
        return mailboxInfo;
    }
    
    try {
        return getMailboxInfoForCoprincipalAccount(mailboxInfo);
    }
    catch {
        // The coprincipal account is unknown
        return mailboxInfo;
    }
}
